(function() {
  var drawer = document.querySelector('[data-vt-search-drawer]');

  if (!drawer || drawer.dataset.searchDrawerInitialized === 'true') {
    return;
  }

  drawer.dataset.searchDrawerInitialized = 'true';

  var input = drawer.querySelector('[data-search-input]');
  var results = drawer.querySelector('[data-search-results]');
  var popular = drawer.querySelector('[data-search-popular]');
  var clearButton = drawer.querySelector('[data-search-clear]');
  var closeButtons = drawer.querySelectorAll('[data-search-close]');
  var form = drawer.querySelector('form');
  var lastFocusedElement = null;
  var searchTimer = null;
  var abortController = null;
  var supportsAbortController = 'AbortController' in window;

  var predictiveSearchUrl = drawer.dataset.predictiveSearchUrl || '/search/suggest';
  var searchUrl = drawer.dataset.searchUrl || '/search';

  function escapeHtml(value) {
    return String(value || '').replace(/[&<>"']/g, function(character) {
      return {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
      }[character];
    });
  }

  function buildSearchUrl(query) {
    return searchUrl + '?q=' + encodeURIComponent(query);
  }

  function setResults(html) {
    results.innerHTML = html;
  }

  function showPopular() {
    setResults(popular.outerHTML);
    input.setAttribute('aria-expanded', 'false');
  }

  function openDrawer() {
    lastFocusedElement = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('vt-search-drawer-open');

    window.setTimeout(function() {
      input.focus();
    }, 40);
  }

  function closeDrawer() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('vt-search-drawer-open');
    input.setAttribute('aria-expanded', 'false');

    if (abortController) {
      abortController.abort();
      abortController = null;
    }

    if (lastFocusedElement && typeof lastFocusedElement.focus === 'function') {
      lastFocusedElement.focus();
    }
  }

  function renderSuggestions(queries) {
    if (!queries.length) {
      return '';
    }

    var items = queries.slice(0, 3).map(function(query) {
      var label = query.text || query.styled_text || '';
      var url = query.url || buildSearchUrl(label);

      return '<li><a href="' + escapeHtml(url) + '">' + escapeHtml(label) + '</a></li>';
    }).join('');

    return [
      '<div class="vt-search-drawer__section">',
      '<h3>Suggestions</h3>',
      '<ul class="vt-search-drawer__suggestions">',
      items,
      '</ul>',
      '</div>'
    ].join('');
  }

  function hasBestSellerBadge(product) {
    return (product.tags || []).some(function(tag) {
      var normalizedTag = String(tag).toLowerCase();
      return normalizedTag === 'best seller' || normalizedTag === 'best-seller' || normalizedTag === 'bestseller';
    });
  }

  function renderProducts(products) {
    if (!products.length) {
      return '';
    }

    var items = products.slice(0, 3).map(function(product) {
      var image = product.featured_image && product.featured_image.url ? product.featured_image.url : product.image;
      var imageAlt = product.featured_image && product.featured_image.alt ? product.featured_image.alt : product.title;
      var badge = hasBestSellerBadge(product) ? '<span class="vt-search-drawer__badge">Best Seller</span>' : '';
      var imageMarkup = image ? '<img src="' + escapeHtml(image) + '" alt="' + escapeHtml(imageAlt) + '" loading="lazy">' : '';

      return [
        '<a class="vt-search-drawer__product" href="' + escapeHtml(product.url) + '">',
        '<span class="vt-search-drawer__product-image">',
        badge,
        imageMarkup,
        '</span>',
        '<span class="vt-search-drawer__product-title">' + escapeHtml(product.title) + '</span>',
        '</a>'
      ].join('');
    }).join('');

    return [
      '<div class="vt-search-drawer__section">',
      '<h3>Products</h3>',
      '<div class="vt-search-drawer__products">',
      items,
      '</div>',
      '</div>'
    ].join('');
  }

  function renderResults(data, query) {
    var resources = data && data.resources && data.resources.results ? data.resources.results : {};
    var queries = resources.queries || [];
    var products = resources.products || [];
    var html = renderSuggestions(queries) + renderProducts(products);

    if (!html) {
      html = '<p class="vt-search-drawer__empty">No results for "' + escapeHtml(query) + '".</p>';
    }

    setResults(html);
    input.setAttribute('aria-expanded', 'true');
  }

  function fetchSuggestions(query) {
    if (abortController) {
      abortController.abort();
    }

    abortController = supportsAbortController ? new AbortController() : null;

    var endpoint = predictiveSearchUrl;
    if (endpoint.indexOf('.json') === -1) {
      endpoint = endpoint.replace(/\/?$/, '.json');
    }

    var requestUrl = endpoint +
      '?q=' + encodeURIComponent(query) +
      '&resources[type]=query,product' +
      '&resources[limit]=3' +
      '&resources[limit_scope]=each' +
      '&resources[options][unavailable_products]=last' +
      '&resources[options][fields]=title,product_type,variants.title,vendor,variants.sku';

    var fetchOptions = { credentials: 'same-origin' };

    if (abortController) {
      fetchOptions.signal = abortController.signal;
    }

    fetch(requestUrl, fetchOptions)
      .then(function(response) {
        if (!response.ok) {
          throw new Error(response.status);
        }

        return response.json();
      })
      .then(function(data) {
        renderResults(data, query);
      })
      .catch(function(error) {
        if (error.name === 'AbortError') {
          return;
        }

        setResults('<p class="vt-search-drawer__error">Search suggestions are unavailable right now.</p>');
      });
  }

  function handleInput() {
    var query = input.value.trim();
    clearButton.hidden = query.length === 0;

    window.clearTimeout(searchTimer);

    if (!query.length) {
      if (abortController) {
        abortController.abort();
      }

      showPopular();
      return;
    }

    searchTimer = window.setTimeout(function() {
      fetchSuggestions(query);
    }, 250);
  }

  document.addEventListener('click', function(event) {
    var searchLink = event.target.closest('a[href="#search"]');

    if (!searchLink) {
      return;
    }

    event.preventDefault();
    openDrawer();
  });

  Array.prototype.forEach.call(closeButtons, function(button) {
    button.addEventListener('click', closeDrawer);
  });

  clearButton.addEventListener('click', function() {
    input.value = '';
    clearButton.hidden = true;
    showPopular();
    input.focus();
  });

  input.addEventListener('input', handleInput);

  form.addEventListener('submit', function(event) {
    if (!input.value.trim()) {
      event.preventDefault();
      input.focus();
    }
  });

  document.addEventListener('keydown', function(event) {
    if (event.key === 'Escape' && drawer.classList.contains('is-open')) {
      closeDrawer();
    }
  });

  if (window.location.hash === '#search') {
    openDrawer();
  }
})();
